module.exports = __webpack_public_path__ + "img/carousel4.c5e03b9b.webp";